
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Ovarian_and_fallopian_tube_tumors_and_primary_peritoneal_cancer",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Ovarian_and_fallopian_tube_tumors_and_primary_peritoneal_cancer.vue